import React from 'react'
import PropTypes from 'prop-types'

import ModalCommon from 'src/components/common/ModalCommon'
import life from 'src/assets/img/common/life.png'
import ArrowRight from 'src/assets/img/common/arrow_right.png'
import PinkHeart from 'src/assets/img/common/heart-pink.png'
import HeartItem from 'src/pages/voiceLive/assets/heart_item.png'

const AddHeartItemModal = ({ open, onClose, possessionHeart, onSubmit }) => {
  const modalButtons = [
    {
      label: 'キャンセル',
      onClick: () => {
        onClose()
      },
      type: 'close'
    },
    {
      label: '決定',
      onClick: () => onSubmit()
    }
  ]

  return (
    <ModalCommon title="確認" open={open} onClose={onClose} buttons={modalButtons}>
      <div className="flex flex-col items-center justify-center bg-[#FFFFFF] text-[#6F9BFF] text-center font-bold px-8 py-4 mb-1">
        <div className="text-[17px]">応援ハート</div>
        <div className="w-fit flex items-center gap-3 text-lg text-[#878787] bg-[#F8F8F8] rounded-lg px-2 py-0.5">
          <img src={life} className="w-6 h-6" />x<span>1</span>
        </div>
        <div className="w-full flex items-center justify-center mt-1">
          <img src={HeartItem} className="w-28" />
        </div>
        <div className="w-full flex items-center justify-between text-[#FF86C8] bg-[#F7F7F7] pl-3 pr-1 py-1 text-left rounded-md mb-2">
          <div className="flex items-center gap-1 text-[15px]">
            <img src={PinkHeart} className="w-6 h-auto" />
            LOVE度
          </div>
          <div className="text-xl bg-white px-3 py-1 rounded whitespace-nowrap">+1</div>
        </div>
        <div className="w-full flex flex-col items-center justify-center gap-1 bg-[#F3F9FF] rounded-lg py-2">
          <div className="text-[17px] font-semibold">所持ピンクダイヤ</div>
          <div className="flex items-center justify-center gap-4 text-[15px] font-bold">
            <span className="text-[#878787]">{possessionHeart}</span>
            <img src={ArrowRight} />
            <span className="text-[#FF4747]">{possessionHeart - 1}</span>
          </div>
        </div>
      </div>
    </ModalCommon>
  )
}

AddHeartItemModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  possessionHeart: PropTypes.number,
  amount: PropTypes.number,
  onSubmit: PropTypes.func
}

export { AddHeartItemModal }
